import React from 'react';

const CSS = `
.sw{position:relative;border:none;padding:0;cursor:pointer;background:#bdc1c8;transition:background-color .25s;outline:none;flex-shrink:0}
.sw:disabled{opacity:.6;cursor:not-allowed}
.sw.on{background:#1cc88a}
.sw .handle{position:absolute;background:#fff;border-radius:50%;transition:left .25s}
.sw.sw-md{width:3rem;height:1.5rem;border-radius:1.5rem}
.sw.sw-md .handle{top:.1875rem;left:.1875rem;width:1.125rem;height:1.125rem}
.sw.sw-md.on .handle{left:1.6875rem}
.sw.sw-sm{width:2.25rem;height:1.2rem;border-radius:1.2rem}
.sw.sw-sm .handle{top:.15rem;left:.15rem;width:.9rem;height:.9rem}
.sw.sw-sm.on .handle{left:1.2rem}
`;

const ToggleSwitch = ({ checked, onChange, size = 'md', disabled = false, label, title }) => (
  <>
    <style>{CSS}</style>
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      title={title}
      disabled={disabled}
      className={`sw sw-${size} ${checked ? 'on' : ''}`}
      onClick={() => onChange(!checked)}
    >
      <span className="handle" />
    </button>
  </>
);

export default ToggleSwitch;
